import { useFormStore } from '@/stores/form'
import use714Actions from '@/composables/actions/use714Actions'

async function currentMobileNumberClick(number) {
  const formStore = useFormStore()
  formStore.form.setValues({
    deliveryMobileNumber: number
  })
}
export default function () {
  return {
    filterMobileNumbers: (options) => use714Actions('filterMobileNumbers', options),
    currentMobileNumberClick
  }
}
